import React, { useEffect, useRef, useState, useCallback, useImperativeHandle, forwardRef } from 'react';
import { Edit, Smile, Trash } from 'react-feather';
import 'cropperjs/dist/cropper.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import SuccessCatAlert from '../../alert-success-cat/alert-success-cat';
import { LIMIT_TEXT_POST as LIMIT_TEXT_POST_ENV } from '../../../utils/vars';
import { useAuth, useMessage } from '../../../global-components/src';
import FormVerifyEmail from '../../FormVerifyEmail/FormVerifyEmail';
import { useAiMentionLimitBanner } from '../../../hooks/useAiMentionLimit';
import AiLimitBanner from '../../ai-limit-banner';
import ReactPlayer from 'react-player';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { errorMessage as errorMessageUtil } from "../../../utils/TextManagerTwo";
import "react-image-crop/dist/ReactCrop.css";
import { ArrowDown, CheckCircle2, ChevronDown, Circle, FileText, Images, ListChecks, Plus, Send, SquarePlay, Trash2, X } from 'lucide-react';
import { buildDraftSnapshot, deleteDraft, hasDraftContent, listDrafts, PostDraft, saveDraft } from '../../../hooks/useDraft';
import { PACOCA_API_URL, REFLEXO_API_URL, VERSONA_API_URL } from '../../../global-components/src/utils/vars';
import Spinner from '../../../global-components/src/components/spinner/spiner';
import "./style.css"
import { useParams } from 'react-router-dom';
import PreviewSearch from '../../../pages/Settings/SearchScreen/preview-search';
import { logEvent } from '../../analytics-tracker';
import { getNativeKeyboardHeight, getNativeNavigationHeight, isIOSWebView, isNewApp, isNewAppAndroid, removeToNativeiOS } from '../../../utils/platform';
import { extractFirstUrl, extractYouTubeId, verifyLinks } from '../../../global-components/src/utils/text';
import { LinkPreview } from '../../Post/Post/link-preview';
import { useTranslation } from 'react-i18next';
import EmojiPickerNative from '../../Textarea/Emojis/emoji-picker-native';
import { compressImage, convertHeic } from '../../../global-components/src/utils/file';
import { uploadToSignedUrl } from '../../../utils/signed-upload';
import { formatUploadBytes, type ResumableVideoUploadProgress, uploadResumableVideo } from '../../../utils/resumable-video-upload';
import CoinDrop from '../../coin-drop/coin-drop';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { RewriteWithAIButton } from '../../rewrite-with-ai-button';
import { useThemeEffects } from '../../../hooks/useThemeEffects';
import AudioRecorderControl, { AudioRecorderControlHandle } from '../../audio-recorder/audio-recorder';
import PostDestinationSelector from './post-destination-selector';

// ─── Tipos ────────────────────────────────────────────────────────────────────

interface FilePreview {
  file: File;
  src: string;
  type?: string;
}

export interface AddPostContentHandle {
  /** Called by the parent's close button — shows draft dialog if there's content */
  requestClose: () => void;
  /** Opens the saved drafts list directly */
  openDrafts: () => void;
}

interface AddPost {
  modalRef?: React.RefObject<HTMLDivElement | null>;
  closeRef?: React.RefObject<HTMLButtonElement | null>;
  setOpen: (val: boolean) => void;
  selectedFiles: FilePreview[];
  setSelectedFiles: React.Dispatch<React.SetStateAction<FilePreview[]>>;
  /** Chamado ao clicar em "Editar" numa imagem — abre o MediaEditor no pai */
  onEditImage: (file: File, index: number) => void;
}

// ─── Componente ───────────────────────────────────────────────────────────────

const AddPostContent = forwardRef<AddPostContentHandle, AddPost>(({
  setOpen,
  closeRef,
  selectedFiles,
  setSelectedFiles,
  onEditImage,
  modalRef,
}, ref) => {
  const [loading, setLoading]               = useState(false);
  const [errorMessage, setErrorMessage]     = useState('');
  const [videoUpload, setVideoUpload]       = useState<ResumableVideoUploadProgress | null>(null);
  const videoUploadAbortRef = useRef<AbortController | null>(null);
  const [text, setText]                     = useState('');
  const [titlePoem, setTitlePoem]           = useState('');
  const [isLimitExceeded, setIsLimitExceeded] = useState(false);
  const { checkAndTrigger } = useThemeEffects()
  const fileInputRef   = useRef<HTMLInputElement>(null);
  const formRef        = useRef<HTMLFormElement>(null);
  const audioInputRef  = useRef<HTMLInputElement>(null);
  const audioRecorderRef = useRef<AudioRecorderControlHandle>(null);
  const { user, token }  = useAuth();
  const aiLimitBannerName = useAiMentionLimitBanner(text, user?.id);
  const [success, setSuccess]               = useState('');
  const textareaRef    = useRef<HTMLTextAreaElement>(null);
  const { t }          = useTranslation();
  const [videoUrl, setVideoUrl]             = useState<string | null>(null);
  const [audioUrl, setAudioUrl]             = useState<string | null>(null);
  const [audioFile, setAudioFile]           = useState<File | null>(null);
  const [audioRecorderActive, setAudioRecorderActive] = useState(false);
  const { id: id_community }               = useParams();
  const [LIMIT_TEXT_POST, setLImitTextPost] = useState(LIMIT_TEXT_POST_ENV);
  const { setMessage }  = useMessage();
  const [youtubeId, setYoutubeId]           = useState<string | null>(null);
  const [previewUrl, setPreviewUrl]         = useState<string | null>(null);
  const [typePost, setTypePost]             = useState<'post' | 'poll' | 'poem'>('post');
  const [bottomPadding, setBottomPadding]   = useState(5);
  const [pollQuestion, setPollQuestion]     = useState('');
  const [pollOptions, setPollOptions]       = useState<string[]>(['', '']);
  const [multipleChoice, setMultipleChoice] = useState(false);
  const [showEmoji, setShowEmoji]           = useState(false);
  const [showCoins, setShowCoins]           = useState(false);
  const [selectedCommunityIds, setSelectedCommunityIds] = useState<number[]>([]);
  const [textareaHeight, setTextareaHeight] = useState(30);
  const [spaceBottom, setSpaceBottom]       = useState(30);
  const canRecordAudio = !!(user?.stamps?.includes('blue') || user?.stamps?.includes('brown'));

  // ── Draft state ──────────────────────────────────────────────────────────
  const [showDraftDialog, setShowDraftDialog] = useState<'prompt' | 'list' | null>(null);
  const [draftSavedMsg, setDraftSavedMsg]     = useState(false);
  const [drafts, setDrafts]                   = useState<PostDraft[]>([]);

  // ── Keyboard height nativo ───────────────────────────────────────────────
  useEffect(() => {
    const handleKeyboardHeightChange = () => {
      const heightKeyboard        = getNativeKeyboardHeight();
      const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;
      setBottomPadding(
        heightKeyboard
          ? heightKeyboard + nativeNavigationHeight + 10
          : nativeNavigationHeight + 10,
      );
    };
    window.addEventListener('keyboardHeightChange', handleKeyboardHeightChange);
    return () => window.removeEventListener('keyboardHeightChange', handleKeyboardHeightChange);
  }, []);

  // ── Resize textarea ──────────────────────────────────────────────────────
  const resizeTextarea = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    const minH = 30;
    setTextareaHeight(minH);
    textarea.style.height = 'auto';
    textarea.scrollTop = 0;
    const scrollHeight = textarea.scrollHeight;
    const maxHeight = parseFloat(getComputedStyle(textarea).maxHeight || '0');
    if (scrollHeight <= minH) {
      setTextareaHeight(minH);
      setSpaceBottom((minH + 300) * -1);
      textarea.style.height = `${minH}px`;
      textarea.style.overflowY = 'hidden';
      return;
    }
    if (maxHeight && scrollHeight > maxHeight) {
      setTextareaHeight(maxHeight);
      setSpaceBottom((minH + 200) * -1);
      textarea.style.height = `${maxHeight}px`;
      textarea.style.overflowY = 'auto';
    } else {
      setTextareaHeight(scrollHeight);
      setSpaceBottom((minH + 350) * -1);
      textarea.style.height = `${scrollHeight}px`;
      textarea.style.overflowY = 'hidden';
    }
  };

  useEffect(() => { resizeTextarea(); }, [text]);

  useEffect(() => {
    if (!showCoins) return;
    const timer = setTimeout(() => setShowCoins(false), 2000);
    return () => clearTimeout(timer);
  }, [showCoins]);

  function ajustaNewApp() {
    if ((isNewApp() && isNewAppAndroid()) || isIOSWebView()) {
      const nativeNavigationHeight = getNativeNavigationHeight();
      if (nativeNavigationHeight && nativeNavigationHeight > 0)
        setBottomPadding(nativeNavigationHeight + 10);
      window.addEventListener('navigationBarHeightChange', ajustaNewApp);
      return () => window.removeEventListener('navigationBarHeightChange', ajustaNewApp);
    }
  }
  useEffect(() => { ajustaNewApp(); }, []);

  // ── Enquete ──────────────────────────────────────────────────────────────
  function addPollOption() {
    if (pollOptions.length >= 6) return;
    setPollOptions([...pollOptions, '']);
  }
  function removePollOption(index: number) {
    if (pollOptions.length <= 2) return;
    setPollOptions(pollOptions.filter((_, i) => i !== index));
  }
  function updatePollOption(index: number, value: string) {
    const updated = [...pollOptions];
    updated[index] = value;
    setPollOptions(updated);
  }

  useEffect(() => {
    if (user?.stamps?.includes('blue')) setLImitTextPost(LIMIT_TEXT_POST_ENV * 2);
  }, [user]);

  // ── Draft helpers ─────────────────────────────────────────────────────────
  const refreshDrafts = useCallback(() => setDrafts(listDrafts()), []);

  const handleSaveDraft = () => {
    saveDraft(buildDraftSnapshot({ text, titlePoem, typePost, pollQuestion, pollOptions, multipleChoice, videoUrl }));
    setShowDraftDialog(null);
    setDraftSavedMsg(true);
    setTimeout(() => setDraftSavedMsg(false), 2500);
    // Now actually close
    setOpen(false);
    closeRef?.current?.click();
    resetForm();
  };

  const handleDiscardDraft = () => {
    setShowDraftDialog(null);
    setOpen(false);
    closeRef?.current?.click();
    resetForm();
  };

  const handleLoadDraft = (draft: PostDraft) => {
    setText(draft.text);
    setTitlePoem(draft.titlePoem);
    setTypePost(draft.typePost);
    setPollQuestion(draft.pollQuestion);
    setPollOptions(draft.pollOptions);
    setMultipleChoice(draft.multipleChoice);
    if (draft.videoUrl) setVideoUrl(draft.videoUrl);
    deleteDraft(draft.id);
    refreshDrafts();
    setShowDraftDialog(null);
  };

  const handleDeleteDraft = (id: string) => {
    deleteDraft(id);
    refreshDrafts();
  };

  /** Called by parent X button instead of closing directly */
  const requestClose = useCallback(() => {
    audioRecorderRef.current?.cancel();
    if (hasDraftContent({ text, titlePoem, pollQuestion, videoUrl })) {
      setShowDraftDialog('prompt');
    } else {
      setOpen(false);
      closeRef?.current?.click();
      resetForm();
    }
  }, [text, titlePoem, pollQuestion, videoUrl]);

  const openDrafts = useCallback(() => {
    refreshDrafts();
    setShowDraftDialog('list');
  }, [refreshDrafts]);

  useImperativeHandle(ref, () => ({ requestClose, openDrafts }), [requestClose, openDrafts]);

  const closeModal = () => {
    setOpen(false);
    closeRef?.current?.click();
  };

  // ── Editar imagem → delega para o pai via onEditImage ────────────────────
  const openEditor = (index: number) => {
    const fileToEdit = selectedFiles[index];
    onEditImage(fileToEdit.file, index);
  };

  const handleRemoveMedia = (index: number) => {
    setSelectedFiles(prev => {
      const file = prev[index];
      if (file?.src) URL.revokeObjectURL(file.src);
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = async (e: any) => {
    setText(e.target.value);
  };

  // ── Submit ───────────────────────────────────────────────────────────────
  const handleSubmit = async (event: any, textLocal = text, gifUrl = '') => {
    const url = PACOCA_API_URL + '/posts';
    if (event) event.preventDefault();
    setLoading(true);

    if (textLocal && verifyLinks(textLocal)) {
      setErrorMessage(t('post.suspiciousLinkPost'));
      setLoading(false);
      return;
    }

    const img   = (document.getElementById('img')   as HTMLInputElement)?.value.trim();
    const video = (document.getElementById('video') as HTMLInputElement)?.value.trim();
    const hasAudio = !!audioFile;

    if (
      typePost !== 'poll' &&
      !text && selectedFiles.length === 0 &&
      !img && !video && !hasAudio && !gifUrl.trim().length
    ) {
      setErrorMessage(t('post.emptyContent'));
      setLoading(false);
      return;
    }

    if (typePost !== 'poll' && text && selectedFiles.length === 0 && !img && !video && !hasAudio && !gifUrl.trim().length) {
      const trimmed = text.trim();
      const lastPostText = localStorage.getItem('lastPostText') ?? '';
      if (trimmed.length < 1) {
        setErrorMessage(t('post.tooShort'));
        setLoading(false);
        return;
      }
      if (trimmed === lastPostText) {
        setErrorMessage(t('post.duplicate'));
        setLoading(false);
        return;
      }
      if (trimmed.length < 3 && lastPostText.length < 3) {
        setErrorMessage(t('post.tooShort'));
        setLoading(false);
        return;
      }
    }

    if (typePost === 'poll') {
      if (!pollQuestion.trim()) {
        setErrorMessage(t('poll.questionRequired'));
        setLoading(false);
        return;
      }
      if (pollOptions.filter(o => o.trim() !== '').length < 2) {
        setErrorMessage(t('poll.minOptions'));
        setLoading(false);
        return;
      }
    }

    setErrorMessage('');

    if (typePost === 'poem') {
      await submitPoem();
      return;
    }

    const formData = new FormData();
    formData.append('text', textLocal);

    if (typePost === 'poll') {
      formData.append('poll', JSON.stringify({
        question: pollQuestion,
        options: pollOptions.filter(o => o.trim() !== ''),
        multiple_choice: multipleChoice,
      }));
    }

    if (gifUrl.trim().length) formData.append('gif_url', gifUrl);
    if (id_community && window.location.pathname.includes('/comunidades/')) {
      formData.append('id_community', String(id_community));
    } else {
      selectedCommunityIds.forEach(communityId =>
        formData.append('community_ids[]', String(communityId)),
      );
    }

    logEvent('novo_post', { categoria: 'Post', acao: 'Novo Post' });

    try {
      const uploadPayload = [
        ...selectedFiles.map(f => ({ type: f.type, file: f.file })),
        ...(audioFile ? [{ type: 'audio', file: audioFile }] : []),
      ];

      let uploadedMedia: Array<{ path: string; type: string }> = [];

      if (uploadPayload.length > 0) {
        const legacyPayload = uploadPayload.filter(item => item.type !== 'video');
        if (legacyPayload.length) {
          const { data: uploadUrls } = await axios.post(
            PACOCA_API_URL + '/generate-upload-urls',
            { files: legacyPayload },
            { headers: { Authorization: `Bearer ${token}` } },
          );
          await Promise.all(uploadUrls.map((item: { url: string; path: string; type: string }, index: number) =>
            uploadToSignedUrl(axios, item.url, legacyPayload[index].file),
          ));
          uploadedMedia.push(...uploadUrls.map((item: { path: string; type: string }) => ({ path: item.path, type: item.type })));
        }

        for (const item of uploadPayload.filter(item => item.type === 'video')) {
          const controller = new AbortController();
          videoUploadAbortRef.current = controller;
          const uploaded = await uploadResumableVideo({
            api: axios,
            apiBaseUrl: PACOCA_API_URL,
            headers: { Authorization: `Bearer ${token}` },
            file: item.file,
            signal: controller.signal,
            onProgress: setVideoUpload,
          });
          uploadedMedia.push({ path: uploaded.path, type: 'video' });
          videoUploadAbortRef.current = null;
        }

        uploadedMedia.forEach(item => {
          if (item.type === 'image') formData.append('images_paths[]', item.path);
          if (item.type === 'video') formData.append('video_path', item.path);
          if (item.type === 'audio') formData.append('audio_path', item.path);
        });
      }

      const response = await axios.post(url, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      localStorage.setItem('lastPostText', textLocal.trim());
      checkAndTrigger(textLocal, "post")
      setShowCoins(response.data.has_token);
      setSuccess(t('post.shared'));
      
      
      if(uploadedMedia.length > 0) submitReflexo(formData);

      if (response.data.has_token) {
        setTimeout(() => cancelPost(), 2000);
      } else {
        cancelPost();
      }
    } catch (err: any) {
      const messageError = errorMessageUtil(err);
      const reason =
        err?.response?.data.reason && err?.response?.status === 403
          ? err?.response?.data.reason
          : null;
      if (reason) setMessage(messageError || t('post.errorSendWarning'), 'error', undefined, undefined, reason);
      else setErrorMessage(messageError);
      console.error(err);
    } finally {
      videoUploadAbortRef.current = null;
      setVideoUpload(null);
      setLoading(false);
    }
  };

  const submitPoem = async () => {
    const url = VERSONA_API_URL + '/poems';
    try {
      const response = await axios.post(
        url,
        { id_user: user?.id ?? 0, text, title: titlePoem, category: 'Outros' },
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } },
      );
      handleSendPoemPacoca(response.data.poem.id);
      setSuccess(t('poem.shared'));
      cancelPost();
    } catch (err: any) {
      const messageError = errorMessageUtil(err);
      const reason =
        err?.response?.data.reason && err?.response?.status === 403
          ? err?.response?.data.reason
          : null;
      if (reason) setMessage(messageError || t('post.errorSendWarning'), 'error', undefined, undefined, reason);
      else setErrorMessage(messageError);
    } finally {
      setLoading(false);
    }
  };
  
  const submitReflexo = async (formData: FormData) => {
    const url = REFLEXO_API_URL + '/posts';
    try {
      formData.append("bucket", "pacoca")
      await axios.post(url, formData, { 
        headers: { 
          Accept: 'application/json',
          Authorization: `Bearer ${token}` 
        } 
      });
    } catch (err: any) {
      
    }
  };

  function clearText(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const withLineBreaks = tmp.innerHTML
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<p[^>]*>/gi, '');
    const temp = document.createElement('div');
    temp.innerHTML = withLineBreaks;
    return (temp.textContent || temp.innerText || '').replace(/\n\s*\n/g, '\n\n').trim();
  }

  const handleSendPoemPacoca = async (poemId: number) => {
    try {
      await axios.post(
        PACOCA_API_URL + '/posts',
        (() => {
          const fd = new FormData();
          fd.append('poem_id', String(poemId));
          fd.append('poem_title', titlePoem);
          fd.append('text', clearText(text));
          if (id_community && window.location.pathname.includes('/comunidades/')) {
            fd.append('id_community', String(id_community));
          } else {
            selectedCommunityIds.forEach(communityId =>
              fd.append('community_ids[]', String(communityId)),
            );
          }
          return fd;
        })(),
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } },
      );
    } catch (err) {
      console.error(err);
    }
  };

  const limitePost = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = event.target.value;
    setText(newText);
    setIsLimitExceeded(newText.length > LIMIT_TEXT_POST);
  };

  const resetForm = () => {
    audioRecorderRef.current?.cancel();
    selectedFiles.forEach(f => URL.revokeObjectURL(f.src));
    setLoading(false);
    setErrorMessage('');
    setText('');
    setTitlePoem('');
    setTypePost('post');
    setSelectedCommunityIds([]);
    setIsLimitExceeded(false);
    setSelectedFiles([]);
    handleRemoveAudio();
    setPreviewUrl(null);
    setYoutubeId(null);
  };

  const cancelPost = () => {
    resetForm();
    closeModal();
  };

  useEffect(() => {
    if (typePost === 'poem') {
      handleRemoveAudio();
      handleRemoveVideo();
      setSelectedFiles([]);
      setPreviewUrl(null);
      setYoutubeId(null);
    }
  }, [typePost]);

  const handleAudioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setAudioFile(file);
      setAudioUrl(currentUrl => {
        if (currentUrl) URL.revokeObjectURL(currentUrl);
        return URL.createObjectURL(file);
      });
    }
  };

  const handleRecordedAudio = useCallback((file: File) => {
    setAudioFile(file);
    setAudioUrl(currentUrl => {
      if (currentUrl) URL.revokeObjectURL(currentUrl);
      return URL.createObjectURL(file);
    });

    if (audioInputRef.current && typeof DataTransfer !== 'undefined') {
      const transfer = new DataTransfer();
      transfer.items.add(file);
      audioInputRef.current.files = transfer.files;
    }
  }, []);

  const handleRemoveVideo = () => {
    setVideoUrl('');
    const video = document.getElementById('video') as HTMLInputElement;
    if (video?.value) video.value = '';
  };

  const handleRemoveAudio = () => {
    setAudioFile(null);
    setAudioUrl(currentUrl => {
      if (currentUrl) URL.revokeObjectURL(currentUrl);
      return '';
    });
    const audio = document.getElementById('audio-post') as HTMLInputElement;
    if (audio) audio.value = '';
  };

  const handleMediaChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || !files.length) return;

    const processedFiles: File[] = [];
    for (let file of Array.from(files)) {
      file = await convertHeic(file);
      file = await compressImage(file);
      processedFiles.push(file);
    }

    setSelectedFiles(prev => {
      const result = [...prev];
      for (const file of processedFiles) {
        const isImage =
          file.type.startsWith('image/') ||
          /\.(jpg|jpeg|png|gif|webp|heic|heif)$/i.test(file.name);
        const isVideo = file.type.startsWith('video/');

        if (isImage) {
          if (result.filter(f => f.type === 'image').length >= 5) continue;
          result.push({ file, src: URL.createObjectURL(file), type: 'image' });
        }
        if (isVideo) {
          result.push({ file, src: URL.createObjectURL(file), type: 'video' });
        }
      }
      return result;
    });

    event.target.value = '';
  };

  const handleFile = async (file: any) => {
    file = await convertHeic(file);
    file = await compressImage(file);
    const type = file.type;
    const dataTransfer = new DataTransfer();

    if (type.startsWith('image/') && fileInputRef.current?.files) {
      dataTransfer.items.add(file);
      fileInputRef.current.files = dataTransfer.files;
      const reader = new FileReader();
      reader.onload = (e) => {
        const src = e.target?.result;
        if (typeof src === 'string')
          setSelectedFiles(prev => [...prev, { file, src, type: 'image' }]);
      };
      reader.readAsDataURL(file);
    } else if (type.startsWith('video/') && fileInputRef.current) {
      const filtered = selectedFiles.filter(f => f.type !== 'video');
      dataTransfer.items.add(file);
      fileInputRef.current.files = dataTransfer.files;
      setSelectedFiles([...filtered, { file, src: URL.createObjectURL(file), type: 'video' }]);
    } else if (type.startsWith('audio/') && audioInputRef.current) {
      handleRecordedAudio(file);
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    if (e.dataTransfer?.files && e.dataTransfer.files.length > 0)
      Array.from(e.dataTransfer.files).forEach(file => handleFile(file));
  };

  useEffect(() => {
    const modal = modalRef?.current;
    const form  = formRef?.current;
    const root  = document.documentElement;
    if (!modal || !form) return;

    const handleDragOver = (event: DragEvent) => {
      event.preventDefault(); event.stopPropagation();
      modal.style.setProperty('border', root.classList.contains('dark') ? '2px dashed #fff' : '2px dashed #000', 'important');
    };
    const handleDragLeave = (event: DragEvent) => {
      event.preventDefault(); event.stopPropagation();
      modal.style.border = 'none';
    };
    const handleDropLocal = (event: DragEvent) => {
      event.preventDefault();
      modal.style.border = 'none';
      handleDrop(event);
    };

    form.addEventListener('dragover', handleDragOver);
    form.addEventListener('dragleave', handleDragLeave);
    form.addEventListener('drop', handleDropLocal);
    return () => {
      form.removeEventListener('dragover', handleDragOver);
      form.removeEventListener('dragleave', handleDragLeave);
      form.removeEventListener('drop', handleDropLocal);
    };
  }, []);

  const handlePaste = (e: any) => {
    if (e.clipboardData.files && e.clipboardData.files.length > 0)
      Array.from(e.clipboardData.files).forEach(file => handleFile(file));
  };

  const handleClickGif = (sticky: string) => handleSubmit(null, text, sticky);

  // ── Render ───────────────────────────────────────────────────────────────
  return (
    <>
      {showCoins && <CoinDrop count={10} />}

      <form ref={formRef} onSubmit={handleSubmit} onDragOver={(e) => e.preventDefault()}>

        {/* ── Botão enviar mobile ── */}
        <div className="none-pc">
          {user?.email_verified_at && (
            <div className="none-pc post-dropdown d-flex align-items-center" id="btn-add-post-mobile">
              <button disabled={loading || isLimitExceeded}
                className="btn-1 btn btn-withou-shadow btn-blue svg-icons-color btn-main d-flex align-items-center">
                {t('post.actions.addPost')}
                {loading && <div style={{ marginLeft: 10 }}><Spinner size="15px" /></div>}
              </button>
              <div className="dropdown">
                <button disabled={loading || isLimitExceeded}
                  className="btn-2 btn btn-withou-shadow btn-blue svg-icons-color btn-main d-flex align-items-center"
                  data-bs-toggle="dropdown" aria-expanded="false"
                  style={{ borderLeft: '1px solid rgba(255,255,255,.3)' }}>
                  <ChevronDown size="15px" />
                </button>
                {!loading && !isLimitExceeded && (
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li><button type="button" className="dropdown-item" onClick={() => setTypePost('post')}>{t('post.title')}</button></li>
                    <li><button type="button" className="dropdown-item" onClick={() => setTypePost('poll')}>{t('poll.title')}</button></li>
                    <li><button type="button" className="dropdown-item" onClick={() => setTypePost('poem')}>{t('poem.title')}</button></li>
                  </ul>
                )}
              </div>
            </div>
          )}
        </div>

        {success && <SuccessCatAlert show={!!success} message={success} onClose={() => setSuccess('')} />}

        {aiLimitBannerName ? <AiLimitBanner aiName={aiLimitBannerName} /> : null}

        {user?.email_verified_at ? (
          <div style={{ position: 'relative' }}>
            {!(id_community && window.location.pathname.includes('/comunidades/')) && (
              <div className="ap-destination-row">
                <PostDestinationSelector
                  selectedCommunityIds={selectedCommunityIds}
                  onChange={setSelectedCommunityIds}
                />
              </div>
            )}

            {/* ── Poema ── */}
            {typePost === 'poem' && (
              <div className="card-add-poll mb-3 mt-3" style={{ margin: '0 10px' }}>
                <input type="text" className="form-control mb-2"
                  placeholder={t('poem.titlePlaceholder')}
                  value={titlePoem} onChange={(e) => setTitlePoem(e.target.value)} maxLength={150} />
                <CKEditor
                  editor={ClassicEditor as any}
                  data={text}
                  config={{
                    toolbar: [
                      'undo', 'redo', '|', 'heading',
                      'bold', 'italic', 'underline', 'strikethrough', '|',
                      'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor', '|',
                      'alignment', 'indent', 'outdent', '|',
                      'bulletedList', 'numberedList', 'todoList', '|',
                      'blockQuote', '|', 'horizontalLine', 'specialCharacters', 'emoji', 'removeFormat',
                    ],
                  }}
                  disabled={loading}
                  onChange={(_event: any, editor: any) => setText(editor.getData())}
                />
              </div>
            )}

            {/* ── Textarea padrão ── */}
            {typePost !== 'poem' && (
              <textarea
                ref={textareaRef}
                value={text}
                onChange={(e) => {
                  limitePost(e);
                  handleChange(e);
                  setYoutubeId(extractYouTubeId(e.target.value));
                  setPreviewUrl(extractFirstUrl(e.target.value));
                }}
                onPaste={handlePaste}
                onDragOver={(e) => e.preventDefault()}
                className={`form-control text-with-emoji text-comment-big text-comment mb-2 ${isLimitExceeded ? 'is-invalid' : ''}`}
                style={{ color: isLimitExceeded ? 'red' : 'inherit' }}
                placeholder={
                  (id_community && !isNaN(Number(id_community))) || selectedCommunityIds.length > 0
                    ? t('post.textNewPostCommunity')
                    : t('post.textNewPost')
                }
              />
            )}

            {/* ── Enquete ── */}
            {typePost === 'poll' && (
              <div
                className="ap-poll-card mb-3"
                style={{
                  margin: '0 10px',
                  padding: 18,
                  borderRadius: 18,
                  border: '1px solid rgba(120,120,120,0.18)',
                  background: 'rgba(120,120,120,0.05)',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                  <ListChecks size={18} />
                  <span style={{ fontWeight: 600, fontSize: 14 }}>{t('poll.title')}</span>
                </div>

                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder={t('poll.questionPlaceholder')}
                  value={pollQuestion}
                  onChange={(e) => setPollQuestion(e.target.value)}
                  maxLength={150}
                  style={{ fontWeight: 600, fontSize: 16, borderRadius: 12 }}
                />

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 10 }}>
                  {pollOptions.map((option, index) => (
                    <div
                      key={index}
                      className="ap-poll-option"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        border: '1px solid rgba(120,120,120,0.25)',
                        borderRadius: 12,
                        padding: '4px 6px 4px 4px',
                        background: 'var(--bs-body-bg, #fff)',
                      }}
                    >
                      <div
                        style={{
                          width: 26,
                          height: 26,
                          minWidth: 26,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 12,
                          fontWeight: 700,
                          background: 'var(--primary-blue)',
                          color: '#fff',
                        }}
                      >
                        {String.fromCharCode(65 + index)}
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        style={{ border: 'none', boxShadow: 'none', padding: '6px 4px', background: 'transparent' }}
                        placeholder={`${t('poll.option')} ${index + 1}`}
                        value={option}
                        onChange={(e) => updatePollOption(index, e.target.value)}
                        maxLength={80}
                      />
                      {pollOptions.length > 2 && (
                        <button
                          type="button"
                          onClick={() => removePollOption(index)}
                          style={{
                            width: 28,
                            height: 28,
                            minWidth: 28,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%',
                            border: 'none',
                            background: 'transparent',
                            color: '#dc3545',
                          }}
                        >
                          <Trash2 size={15} />
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                {pollOptions.length < 6 && (
                  <button
                    type="button"
                    onClick={addPollOption}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 6,
                      padding: '8px 0',
                      borderRadius: 12,
                      border: '1px dashed rgba(120,120,120,0.4)',
                      background: 'transparent',
                      fontSize: 13,
                      fontWeight: 500,
                      color: 'inherit',
                    }}
                  >
                    <Plus size={14} /> {t('poll.addOption')}
                  </button>
                )}

                <div
                  onClick={() => setMultipleChoice(!multipleChoice)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: 14,
                    padding: '10px 12px',
                    borderRadius: 12,
                    background: 'rgba(120,120,120,0.06)',
                    cursor: 'pointer',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {multipleChoice ? <CheckCircle2 size={18} color="var(--primary-blue)" /> : <Circle size={18} color="#999" />}
                    <span style={{ fontSize: 13 }}>{t('poll.allowMultipleChoices')}</span>
                  </div>
                  <div
                    style={{
                      width: 38,
                      height: 22,
                      borderRadius: 999,
                      background: multipleChoice ? 'var(--primary-blue)' : 'rgba(120,120,120,0.35)',
                      position: 'relative',
                      transition: 'background 0.2s',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: 2,
                        left: multipleChoice ? 18 : 2,
                        width: 18,
                        height: 18,
                        borderRadius: '50%',
                        background: '#fff',
                        transition: 'left 0.2s',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
                      }}
                    />
                  </div>
                </div>

                <div style={{ textAlign: 'right', fontSize: 11, opacity: 0.6, marginTop: 6 }}>
                  {pollOptions.filter(o => o.trim()).length}/6 {t('poll.option')}
                </div>
              </div>
            )}

            <EmojiPickerNative
              show={showEmoji} setShow={setShowEmoji}
              onSelect={(emoji) => setText(prev => prev + emoji)}
              handleClickGif={handleClickGif}
              bottom={`${String(bottomPadding + (window.innerWidth <= 850 ? 10 : spaceBottom))}px`}
            />
            <PreviewSearch textareaRef={textareaRef} text={text} setText={setText} />

            {/* ── Toolbar inferior ── */}
            <div className={`ap-toolbar ${audioRecorderActive ? 'ap-toolbar-audio-active' : ''}`}>
              {!audioRecorderActive && typePost !== 'poem' && !removeToNativeiOS(user.id) && (
                <div className="ap-toolbar-icon" onClick={() => fileInputRef.current?.click()}>
                  <Images className='icon-add-emoji' />
                </div>
              )}
              {canRecordAudio && typePost === 'post' && !removeToNativeiOS(user.id) && (
                <AudioRecorderControl
                  ref={audioRecorderRef}
                  onRecorded={handleRecordedAudio}
                  onError={setErrorMessage}
                  onActiveChange={setAudioRecorderActive}
                  audioLabel={t('chat.message.audio')}
                  cancelLabel={t('generics.cancel')}
                  holdLabel={t('chat.recording.holdToRecord', { defaultValue: 'Segure para gravar' })}
                  microphoneError={t('chat.microphoneError')}
                  sendLabel={t('generics.send')}
                />
              )}
              {!audioRecorderActive && typePost !== 'poem' && (
                <>
                  <div className="ap-toolbar-icon" onClick={() => setShowEmoji(true)}>
                    <Smile className='icon-add-emoji' />
                  </div>
                </>
              )}
              {!audioRecorderActive && (
                <>
                  <RewriteWithAIButton
                    type={typePost === 'poem' ? 'poem' : 'post'}
                    setError={setErrorMessage}
                    getText={() => text}
                    onSuccess={(newText) => setText(newText)}
                  />
                  <div className="ap-toolbar-spacer" />
                  <span className={`ap-char-count ${isLimitExceeded ? 'limit' : ''}`}>
                    {text.length}/{LIMIT_TEXT_POST}
                  </span>
                </>
              )}
            </div>

            <div style={{ padding: '0px 0px' }}>
              <input type="hidden" name="group_id" value="{{isset($group) ? $group->id : 0}}" id="group_id" />

{errorMessage && <div className="ap-error-box">{errorMessage}</div>}

{videoUpload && (
  <div className="ap-error-box" role="status" style={{ background: 'rgba(31, 117, 204, .1)', color: 'inherit' }}>
    <strong>{videoUpload.state === 'retrying' ? 'Reconectando o vídeo…' : videoUpload.state === 'resuming' ? 'Retomando o vídeo…' : 'Enviando vídeo…'}</strong>{' '}
    {Math.round((videoUpload.confirmedBytes / Math.max(videoUpload.totalBytes, 1)) * 100)}% · {formatUploadBytes(videoUpload.confirmedBytes)} de {formatUploadBytes(videoUpload.totalBytes)}
    {videoUpload.speedBytesPerSecond ? ` · ${formatUploadBytes(videoUpload.speedBytesPerSecond)}/s` : ''}
    <button type="button" onClick={() => videoUploadAbortRef.current?.abort()} style={{ marginLeft: 10 }}>Cancelar</button>
  </div>
)}

              {previewUrl && !youtubeId && !selectedFiles.length && <LinkPreview url={previewUrl} />}

              {youtubeId && !selectedFiles.length && (
                <iframe
                  className="preview-ty-add-post"
                  src={`https://www.youtube.com/embed/${youtubeId}`}
                  title="YouTube preview"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}

              <input type="file" ref={fileInputRef} multiple accept="image/*,video/*"
                onChange={handleMediaChange} style={{ display: 'none' }} name="img" id="img" />
              <input ref={audioInputRef} onChange={handleAudioChange}
                type="file" name="audio" id="audio-post" className="d-none" accept="audio/*" />

              {/* ── Previews de imagem/vídeo ── */}
              <div className={`row-preview-img ${selectedFiles.length > 1 ? 'row-preview-img-multiple' : ''}`} style={{ paddingBottom: 0 }}>
                {selectedFiles.map((file, index) => (
                  <React.Fragment key={index}>
                    {file.type === 'image' ? (
                      <div className="row-label-img">
<div className="ap-media-actions">
  <button type="button" className="ap-media-btn" onClick={() => openEditor(index)}>
    <Edit size={13} /> {t('post.actions.edit')}
  </button>
  <button type="button" className="ap-media-btn ap-media-btn-danger" onClick={() => handleRemoveMedia(index)}>
    <X size={15} />
  </button>
</div>
                        <img alt={`preview-${index}`} src={file.src} className="label-img img-preview-add" />
                      </div>
                    ) : (
                      <div className="row row-label-video"
                        style={{ margin: 0, height: '100%', minHeight: selectedFiles.length > 1 ? 300 : 250, overflow: 'auto', position: 'relative' }}>
                        <button type="button" onClick={() => handleRemoveMedia(index)}
                          className="btn-x-right btn-close svg-icons-color btn-dark">
                          <X />
                        </button>
                        <label className="label-img label-video"
                          style={{ minHeight: selectedFiles.length > 1 ? 300 : 0 }} htmlFor="video">
                          <ReactPlayer url={file.src}
                            style={{ objectFit: 'cover', minHeight: selectedFiles.length > 1 ? 300 : 250, maxHeight: selectedFiles.length > 1 ? 300 : 250 }}
                            controls width="100%" className="video-preview" />
                        </label>
                      </div>
                    )}
                  </React.Fragment>
                ))}

                {/* Preview vídeo por URL */}
                <div className="row row-label-video"
                  style={{ margin: 0, height: '100%', minHeight: selectedFiles.length > 1 ? 300 : 400, display: videoUrl ? 'block' : 'none', overflow: 'auto', position: 'relative' }}>
                  <button type="button" onClick={handleRemoveVideo} className="btn-x-right btn-close svg-icons-color btn-dark"><X /></button>
                  <label className="label-img label-video" style={{ minHeight: selectedFiles.length > 1 ? 300 : 0 }} htmlFor="video">
                    <ReactPlayer url={videoUrl || ''}
                      style={{ objectFit: 'cover', minHeight: selectedFiles.length > 1 ? 300 : 400, maxHeight: selectedFiles.length > 1 ? 300 : 400 }}
                      controls width="100%" className="video-preview" />
                  </label>
                </div>
              </div>

              {/* Preview áudio */}
              <div className="row row-label-video"
                style={{ margin: 0, marginTop: 5, display: audioUrl ? 'block' : 'none', overflow: 'auto', position: 'relative' }}>
                <div onClick={handleRemoveAudio} className="btn-x-right btn-close svg-icons-color btn-dark"><X /></div>
                <label className="label-img label-audio" htmlFor="audio">
                  <AudioPlayer className="audio-preview" src={audioUrl || ''} />
                </label>
              </div>
            </div>

            {/* ── Rodapé desktop ── */}
            <div className="none-cel">
              <div className="modal-footer mt-3 none-cel" style={{ padding: '0' }}>
                <div className="loading-post" />
                <div className="none-cel ap-desktop-footer-actions">
                  <div className="ap-desktop-footer-action">
                    <button type="button" className="btn btn-subimit-post btn-secondary ap-desktop-footer-cancel"
                      onClick={() => requestClose()}>{t('generics.cancel')}</button>
                  </div>
                  <div className="ap-desktop-footer-action">
                    {user?.email_verified_at && (
                      <div className="btn-subimit-post none-pc post-dropdown d-flex align-items-center ap-desktop-footer-submit" id="btn-add-post-pc">
                        <button disabled={loading || isLimitExceeded}
                          className="btn-1 btn btn-blue svg-icons-color btn-main d-flex align-items-center">
                          {t('post.actions.addPost')}
                          {loading && <div style={{ marginLeft: 10 }}><Spinner size="15px" /></div>}
                        </button>
                        <div className="dropdown">
                          <button disabled={loading || isLimitExceeded}
                            className="btn-2 btn btn-blue svg-icons-color btn-main d-flex align-items-center"
                            data-bs-toggle="dropdown" aria-expanded="false"
                            style={{ borderLeft: '1px solid rgba(255,255,255,.3)' }}>
                            <ChevronDown size="15px" />
                          </button>
                          {!loading && !isLimitExceeded && (
                            <ul className="dropdown-menu dropdown-menu-end">
                              <li><button type="button" className="dropdown-item" onClick={() => setTypePost('post')}>{t('post.title')}</button></li>
                              <li><button type="button" className="dropdown-item" onClick={() => setTypePost('poll')}>{t('poll.title')}</button></li>
                              <li><button type="button" className="dropdown-item" onClick={() => setTypePost('poem')}>{t('poem.title')}</button></li>
                            </ul>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col" style={{ padding: 20 }}>
            <p style={{ marginBottom: 10 }}>{t('post.verifyEmailToPost')}</p>
            <FormVerifyEmail onSend={closeModal} />
          </div>
        )}
      </form>

      {/* ── Draft saved toast ── */}
      {draftSavedMsg && (
        <div className="ap-draft-toast">
          <FileText size={14} />
          {t('post.draft.saved')}
        </div>
      )}

      {/* ── Draft prompt overlay ── */}
      {showDraftDialog === 'prompt' && (
        <div className="ap-draft-overlay" onClick={() => setShowDraftDialog(null)}>
          <div className="ap-draft-card" onClick={(e) => e.stopPropagation()}>
            <p className="ap-draft-title">{t('post.draft.saveQuestion')}</p>
            <p className="ap-draft-desc">{t('post.draft.saveDesc')}</p>
            <div className="ap-draft-actions">
              <button className="ap-draft-btn ap-draft-btn-ghost" onClick={handleDiscardDraft}>
                {t('post.draft.discard')}
              </button>
              <button className="ap-draft-btn ap-draft-btn-primary" onClick={handleSaveDraft}>
                <FileText size={14} />
                {t('post.draft.saveDraft')}
              </button>
            </div>
            {listDrafts().length > 0 && (
              <button className="ap-draft-view-link" onClick={() => { refreshDrafts(); setShowDraftDialog('list'); }}>
                {t('post.draft.myDrafts')} ({listDrafts().length})
              </button>
            )}
          </div>
        </div>
      )}

      {/* ── Draft list overlay ── */}
      {showDraftDialog === 'list' && (
        <div className="ap-draft-overlay" onClick={() => setShowDraftDialog(null)}>
          <div className="ap-draft-card ap-draft-card-list" onClick={(e) => e.stopPropagation()}>
            <div className="ap-draft-list-header">
              <p className="ap-draft-title">{t('post.draft.myDrafts')}</p>
              <button className="ap-draft-close-btn" onClick={() => setShowDraftDialog(null)}>
                <X size={16} />
              </button>
            </div>
            {drafts.length === 0 ? (
              <p className="ap-draft-empty">{t('post.draft.noDrafts')}</p>
            ) : (
              <ul className="ap-draft-list">
                {drafts.map((d) => (
                  <li key={d.id} className="ap-draft-item">
                    <div className="ap-draft-item-body">
                      <span className="ap-draft-item-preview">
                        {d.text.trim() || d.titlePoem.trim() || d.pollQuestion.trim() || '...'}
                      </span>
                      <span className="ap-draft-item-date">
                        {new Date(d.savedAt).toLocaleDateString()} {new Date(d.savedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                    <div className="ap-draft-item-actions">
                      <button className="ap-draft-item-btn ap-draft-item-load" onClick={() => handleLoadDraft(d)}>
                        {t('post.draft.resume')}
                      </button>
                      <button className="ap-draft-item-btn ap-draft-item-del" onClick={() => handleDeleteDraft(d.id)}>
                        <Trash2 size={13} />
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </>
  );
});

AddPostContent.displayName = 'AddPostContent';

export default AddPostContent;
